import { defineMessages } from 'react-intl';

const scope = 'cb.screens.UsedCoupons';

export default defineMessages({
  cantCancelErrorMessage: {
    id: `${scope}.cantCancelErrorMessage`,
    defaultMessage: "Can't cancel coupon. Error: {errorMessage}.",
  },
});
